import React, { Component, Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import Logo from 'components/Logo';
import Footer from 'components/Footer';

const App = lazy(() => import('containers/App'));
const SinglePage = lazy(() => import('components/SinglePage'));
const Japan = lazy(() => import('components/Japan'));
const Babyshower = lazy(() => import('components/Babyshower'));

class Root extends Component {
  render() {
    return (
      <Router>
        <Suspense fallback={<div>...</div>}>
          <div className="container">
            <div className="row">
              <Logo />
            </div>
            <Route exact path="/" component={App} />
            <Route exact path="/p/:id" component={SinglePage} />
            <Route exact path="/japan/:xa" component={Japan} />
            <Route exact path="/babyshower/:xa" component={Babyshower} />
            <div className="row">
              <Footer />
            </div>
          </div>
        </Suspense>
      </Router>
    );
  }
}

export default hot(module)(Root);
